import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { XCircle } from "lucide-react";

interface RejectedClaim {
  id: string;
  nursing_home_id: string;
  status: string;
  created_at: string;
  updated_at: string;
  notes?: string | null;
  nursing_home?: {
    center_name: string;
    town: string;
    county: string;
    county_slug: string;
    nh_slug: string;
  };
}

interface RejectedClaimsProps {
  claims: RejectedClaim[];
  isLoading: boolean;
}

export function RejectedClaims({ claims, isLoading }: RejectedClaimsProps) {
  if (isLoading || !claims || claims.length === 0) {
    return null;
  }

  return (
    <Card className="mb-6 border-destructive/30">
      <CardHeader className="border-b border-gray-100">
        <CardTitle className="text-lg flex items-center gap-2">
          <XCircle className="h-5 w-5 text-destructive" />
          Rejected claims
        </CardTitle>
        <p className="text-sm text-muted-foreground">
          These claims were not approved. Contact support if you think this is a mistake.
        </p>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y divide-gray-100">
          {claims.map((claim) => (
            <div key={claim.id} className="p-4">
              <h3 className="font-semibold text-lg mb-1">
                {claim.nursing_home?.center_name || "Nursing home"}
              </h3>
              {claim.nursing_home && (
                <p className="text-sm text-muted-foreground mb-2">
                  {claim.nursing_home.town}, {claim.nursing_home.county}
                </p>
              )}
              {claim.notes ? (
                <p className="text-sm bg-muted/50 rounded-md p-3 mt-2">
                  <span className="font-medium">Note: </span>
                  {claim.notes}
                </p>
              ) : null}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
